var $ = jQuery;

const A11YFix = {
  FixFooterToggle: function () {
    $("#footer .footer-menu ul > li .toggle-footer-link").each(function () {
      $(this).attr("aria-expanded", "false");
      $(this).click(function () {
        event.preventDefault();
        $(this).parent().click();
        $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
      });
      $(this).keydown(function (event) {
        if (event.key == "Enter") {
          $(this).click();
        }
      });
    });
  },
  FixAnnon: function () {
    $(".custom-favorite-checkbox").each(function () {
      $(this).attr({
        "aria-checked": this.classList.toggle("active") ? "true" : "false",
      });
      $(this).click(function () {
        $(this).attr("aria-checked", $(this).attr("aria-checked") == "false");
      });
    });
    $(".section-slideshow .swiper-prev, .section-slideshow .swiper-next").each(
      function () {
        var that = this;
        $(this).click(function () {
          setTimeout(function () {
            $(that)
              .closest(".section-slideshow")
              .find(".swiper-slide-visible")
              .last()
              .find("a")
              .first()
              .focus();
          }, 500);
        });
      }
    );
    $(document).on(
      "keydown",
      "#yotpo-widget-btn, #yotpo-main-widget-btn",
      function (event) {
        if (event.key == "Enter") {
          $(this).click();
          event.preventDefault();
        }
      }
    );
  },
  FixMainMenu: function () {
    const descriptionId = "menu-description-a11y";
    $("body").append(
      '<p class="sr-only" id="' +
        descriptionId +
        '">Use down arrow key to expand, escape to collapse, enter/space to activate the link</p>'
    );
    $(".header__nav > ul > li").each(function () {
      $(this)
        .find(".nav_item__wrap > a.nav_item__link")
        .each(function () {
          $(this).attr("aria-expanded", "false");
          $(this).attr("aria-describedby", descriptionId);
          $(this).keydown(function (event) {
            if (event.key == "ArrowDown") {
              $(this).closest("li.nav__item.group").addClass("open-menu");
              $(this).attr("aria-expanded", true);
              event.preventDefault();
            } else if (event.key == "ArrowUp" || event.key == "Escape") {
              $(this).closest("li.nav__item").removeClass("open-menu");
              $(this).attr("aria-expanded", false);
              event.preventDefault();
            }
          });
        });
      $(this)
        .find(".mega-menu a")
        .each(function () {
          $(this).keydown(function (event) {
            if (event.key == "ArrowUp" || event.key == "Escape") {
              $(this).closest("li.nav__item.group").removeClass("open-menu");
              const mainElem = $(this)
                .closest("li.nav__item.group")
                .find(".nav_item__wrap > a.nav_item__link");
              mainElem.attr("aria-expanded", false);
              mainElem.focus();
              event.preventDefault();
            }
          });
        });
    });
  },
  FixSliders: function () {
    $("#swiperVideoPlay").click(function () {
      let video = $(this)
        .closest(".a11y-container-class")
        .find(".swiper-slide-visible video")
        .get(0);
      if (video.paused) {
        video.play();
        $(this).attr("aria-pressed", false);
      } else {
        video.pause();
        $(this).attr("aria-pressed", true);
      }
    });
    $(".swiper-container").each(function () {
      var that = this;
      $(this).parent().addClass("a11y-container-class");
      $(that)
        .closest(".a11y-container-class")
        .find(".swiper-slide:not(.swiper-slide-visible)")
        .find("a,button")
        .attr({ tabindex: "-1" });
      $(that)
        .closest(".a11y-container-class")
        .find(".swiper-slide-visible")
        .find("a,button")
        .attr({ tabindex: "0" });
      $(that)
        .closest(".a11y-container-class")
        .find(".swiper-slide:not(.swiper-slide-visible)")
        .attr({ tabindex: "-1", "aria-hidden": "true" });
      $(that)
        .closest(".a11y-container-class")
        .find(".swiper-slide-visible")
        .removeAttr("tabindex")
        .removeAttr("aria-hidden");
      SwiperInstance = $(this)[0].swiper;
      if (SwiperInstance) {
        SwiperInstance.autoplay.stop();
        SwiperInstance.on("slideChange", function () {
          console.log("slide changed");
        });
        SwiperInstance.on("slideChangeTransitionEnd", function () {
          console.log("SwiperInstance");
          $('.product-gallery-thumbnails .a11y_click[tabindex="0"]').removeAttr(
            "aria-current"
          );
          $(
            '.product-gallery-thumbnails .active .a11y_click[tabindex="0"]'
          ).attr("aria-current", true);
          $(that)
            .closest(".a11y-container-class")
            .find(".swiper-slide:not(.swiper-slide-visible)")
            .find("a,button")
            .attr({ tabindex: "-1" });
          $(that)
            .closest(".a11y-container-class")
            .find(".swiper-slide-visible")
            .find("a,button")
            .attr({ tabindex: "0" });
          $(that)
            .closest(".a11y-container-class")
            .find(".swiper-slide:not(.swiper-slide-visible)")
            .attr({ tabindex: "-1", "aria-hidden": "true" });
          $(that)
            .closest(".a11y-container-class")
            .find(".swiper-slide-visible")
            .removeAttr("tabindex")
            .removeAttr("aria-hidden");
        });
      }
    });
  },
  FixCart: function () {
    // $("body").on("focus", "#cart-end", function (event) {
    //   console.log("cart-end");
    //   event.preventDefault();
    //   $(this).parent().find(".a11y_cart_close").focus();
    // });
  },
};

function focusClose(elem) {
  setTimeout(function () {
    $(this).parent().find(".a11y_cart_close").focus();
    console.log("focusClose", elem);
  }, 250);
}

function trapFocus(element) {
  var focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])'
    ),
    firstFocusableEl = focusableEls[0],
    lastFocusableEl = focusableEls[focusableEls.length - 1],
    KEYCODE_TAB = 9;

  firstFocusableEl.focus(); // Focus to first focusable element in the modal

  element.addEventListener("keydown", function (e) {
    var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

var KeepChecking = function (selector, call) {
  let timer;
  let isObserving = false;
  $("body").each((i, body) => {
    const observer = new MutationObserver((mutations) => {
      const elem = $(selector);
      if (elem.length) {
        clearTimeout(timer);
        isObserving = true;
        timer = setTimeout(() => {
          if (isObserving) {
            call();
            isObserving = false;
          }
        }, 100);
      } else {
        isObserving = false;
      }
    });
    observer.observe(body, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  });
};
$(".product-essentials--buy-box a.active").attr("aria-current", "true");

$(document).ready(function () {
  var cart = document.getElementById("shopify-section-cart-modal");
  trapFocus(cart);

  // KeepChecking('.CampaignType--popup', function () {
  //   var Campaign = document.getElementByClass('CampaignType--popup');
  //   trapFocus(Campaign);
  // });

  KeepChecking("#storyViewer", function () {
    var storyview = document.getElementById("storyViewer");
    $(".yotpo-bottomline.pull-left.star-clickable").removeAttr("tabindex");
  });

  $("#shopify-section-header").attr("role", "banner");
  $('img:not([alt]), img[alt=" "]').attr("alt", "");

  $(".cart__item_details div button").click(function (e) {
    setTimeout(function () {
      $(e.target).focus();
    }, 1000);
  });

  setTimeout(function () {
    $(".a11y_rem_role a").removeAttr("role");
    $(".a11y_rem_role a").removeAttr("aria-label");

    // $('.a11y_rem_role a').each(function(){
    // var items =  $(this).attr('aria-label');
    // var linktext = $(this).text().trim();
    // $(this).attr('aria-label', linktext +' '+items);
    // });

    $(".section-slideshow").each(function () {
      var title = $(this).find("aside .font-bold").text().trim();
      if (title.trim() != "") {
        $(this)
          .find(".swiper-prev.swiper-button-prev-unique")
          .attr("aria-label", "Previous slide of" + " " + title);
        $(this)
          .find(".swiper-next.swiper-button-next-unique")
          .attr("aria-label", "Next Slide of" + " " + title);
      }
    });

    $(".section-slideshow aside h1").attr({
      role: "heading",
      "aria-level": "2",
    });
  }, 1000);

  $(".section-slideshow").each(function () {
    var title = $(this).find("aside .font-bold").text().trim();
    if (title.trim() != "") {
      $(this)
        .find(".swiper-prev.swiper-button-prev-unique")
        .attr("aria-label", "Previous slide of" + " " + title);
      $(this)
        .find(".swiper-next.swiper-button-next-unique")
        .attr("aria-label", "Next Slide of" + " " + title);
    }
  });

  $(".mega__link_list .nav__list_item_parent").each(function () {
    $(this).find("svg, span.sr-only").attr("aria-hidden", "true");
  });

  $("footer .list-none svg").attr("aria-hidden", "true");

  $(".a11y_rem_btn a button").replaceWith(function () {
    return $("<div class='button' />").append($(this).contents());
  });

  $(".footer-company").each((i, wrap) => {
    $(wrap)
      .find("> ul:not(#social-icons)")
      .each((i, ul) => {
        $(ul).find("br").attr("aria-hidden", true);
        $(ul).attr("role", "none");
        $(ul).find("> li").wrapAll("<ul></ul>");
      });
  });

  // $(".blog-menu").each((i, menu) => {
  //   $(menu)
  //     .find("details")
  //     .each((i, details) => {
  //       function handleChange() {
  //         $(details)
  //           .find(".blog-nav-item > div[aria-expanded]")
  //           .attr({
  //             tabindex: 0,
  //             role: "button",
  //             "aria-expanded": details.hasAttribute("open"),
  //           });
  //       }

  //       handleChange();

  //       const observer = new MutationObserver(() => {
  //         handleChange();
  //       });

  //       observer.observe(details, {
  //         attributes: true,
  //       });
  //     });
  // });

  $(".collection-filters").each((i, filters) => {
    $(filters)
      .find("details")
      .each((i, details) => {
        $(details)
          .find("ul[aria-controlledby]")
          .removeAttr("aria-controlledby");
      });
  });

  $("#privacy-policy-registration-information-sunny-health").each((i, page) => {
    $(page)
      .find("ul > ul")
      .each((i, ul) => {
        $(ul).wrap("<li></li>");
      });
  });

  var i = 1;
  $('iframe[src*="https://www.facebook.com"]').each(function () {
    $(this).attr("title", "Facebook post " + i);
    i++;
  });
  var j = 1;
  $('iframe[src*="https://www.instagram.com"]').each(function () {
    $(this).attr("title", "Instagram post " + j);
    j++;
  });
  var k = 1;
  $('iframe[src*="https://www.youtube.com"]').each(function () {
    $(this).attr("title", "Youtube post " + k);
    k++;
  });

  $(".a11y_expandable").attr("aria-expanded", "false");
  $("details[open] summary.a11y_expandable").attr("aria-expanded", "true");
  $(".a11y_expandable").click(function () {
    $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
  });

  $(".header__nav .mega-menu").removeAttr("tabindex");
  $(
    ".product-essentials--buy-box .product-essentials--.font-bold svg, .product-essentials--.font-bold span.sr-only"
  ).attr("aria-hidden", "true");

  $(".swiper-wrapper.items-baseline .swiper-slide").each(function () {
    var size = $(this).find(".text-yellow-300 svg").length;
    $(this)
      .find(".text-yellow-300")
      .after(`<span class="sr-only">${size} star ratings</span>`);
    $(this).find(".text-yellow-300").attr("aria-hidden", "true");
  });

  $(".shopify-section.accordion h2").attr({
    role: "heading",
    "aria-level": "3",
  });
  $(
    "table.a11y_remove, table.a11y_remove tr, table.a11y_remove td, table.a11y_remove tbody, table.a11y_remove th"
  ).attr("role", "none");
  $("table.a11y_remove th strong").attr({ role: "heading", "aria-level": "2" });
  $(".a11y_h2_h3").attr({ role: "heading", "aria-level": "3" });
  $(
    "#troubleshooting-guides-equipment-sunny-health-amp-fitness table.a11y_remove th strong"
  ).attr({ role: "heading", "aria-level": "4" });

  $("input#Search-header").keydown(function (event) {
    if (event.which == "13") {
      event.target.click();
      setTimeout(function () {
        $("#modalSearchInput").focus();
      }, 250);
      event.preventDefault();
    }
  });

  $("div.mega-menu").each(function () {
    $(this).removeAttr("tabindex");
  });

  var tabs = $('.a11y_tabs li[role="tab"]');

  // Set initial tab as active
  tabs
    .first()
    .attr({
      tabindex: "0",
      "aria-selected": "true",
    })
    .addClass("active");

  tabs.on("keydown", function (e) {
    var currentIndex = tabs.index(this);

    if (e.which === 39) {
      // Right arrow key
      currentIndex = (currentIndex + 1) % tabs.length;
    } else if (e.which === 37) {
      // Left arrow key
      currentIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (e.which === 13) {
      // Enter key
      $(this).click();
      var target = $(this).data("target");
      tabs
        .attr({
          tabindex: "-1",
          "aria-selected": "false",
        })
        .removeClass("active");
      $(this)
        .attr({
          tabindex: "0",
          "aria-selected": "true",
        })
        .addClass("active");
      $(target).addClass("active");
    }

    tabs
      .attr({
        tabindex: "-1",
      })
      .removeClass("active");
    tabs
      .eq(currentIndex)
      .attr({
        tabindex: "0",
      })
      .addClass("active");
    tabs.eq(currentIndex).focus();
  });

  tabs.on("click", function () {
    var target = $(this).data("target");
    tabs
      .attr({
        tabindex: "-1",
        "aria-selected": "false",
      })
      .removeClass("active");
    $(this)
      .attr({
        tabindex: "0",
        "aria-selected": "true",
      })
      .addClass("active");
    $(target).addClass("active");
  });

  $(".a11y_click").keydown(function (event) {
    if (event.which == "13") {
      $(this).click();
    }
  });

  $(".a11y_cart").click(function () {
    setTimeout(function () {
      $('[data-modal="cart"] .cart__title').focus();
    }, 250);
  });
  $(".a11y_cart_close").click(function () {
    $(".a11y_cart").focus();
  });

  $(".shopify-section-inspiration-gallery-grid .alt_null").attr("alt", "");

  $(".footer-section").each((i, footer) => {
    const copyright = $(footer).find("#bottom-footer div");
    const form = $(`
			<form class="color-scheme-form">
				<label for="color-scheme-switcher">Color Scheme</label>
				<select class="color-scheme-switcher" id="color-scheme-switcher">
					<option value="default">Default</option>
					<option value="accessible">Accessible</option>
				</select>
			</form>
		`);

    const selectedValue = localStorage.getItem("color-scheme");
    const select = form.find("#color-scheme-switcher");

    select.on("change", (e) => {
      $(":root").attr({
        "data-color-scheme": e.target.value,
      });

      localStorage.setItem("color-scheme", e.target.value);
    });

    if (selectedValue) {
      $(":root").attr({
        "data-color-scheme": selectedValue || value,
      });

      select.val(selectedValue);
    }

    copyright.append(form);
  });

  A11YFix.FixFooterToggle();
  A11YFix.FixMainMenu();
  A11YFix.FixAnnon();
  console.log("ready!");
});

$(window).on("load", function () {
  $(
    ".story-nav-items-shop-by-category, .story-nav-items-shop-by-exercise, .story-nav-items-shop-by-goal"
  ).each((i, slider) => {
    $(slider).find('li[role="group"]').removeAttr("role");
  });

  $(".accordion--section").each((i, section) => {
    $(section)
      .find(".accordion")
      .each((i, accordion) => {
        function handleChange() {
          $(accordion).find(".accordion-panel").removeAttr("aria-hidden");
        }

        handleChange();

        const observer = new MutationObserver((mutations) => {
          setTimeout(() => {
            handleChange();
          }, 100);
        });

        observer.observe(accordion, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
  });

  $(".yotpo-score-filter, .yotpo-media-filter").each((i, filter) => {
    function handleChange() {
      if (filter.hasAttribute("aria-expanded")) {
        $(filter).removeAttr("aria-expanded");
      }

      $(".yotpo-thumbnail[aria-selected]").removeAttr("aria-selected");
    }

    handleChange();

    const observer = new MutationObserver((mutations) => {
      setTimeout(() => {
        handleChange();
      }, 100);
    });

    observer.observe(filter, {
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });
  });

  $(".yotpo-media-filter").each((i, filter) => {
    function handleChange() {
      $(filter)
        .find(".yotpo-media-select")
        .attr({
          "aria-checked": $(filter).attr("aria-checked"),
        });

      setTimeout(() => {
        $(filter).removeAttr("aria-checked").removeAttr("tabindex");
      }, 100);
    }

    handleChange();

    const observer = new MutationObserver(() => {
      handleChange();
    });

    observer.observe(filter, {
      attributes: true,
      attributeFilter: ["aria-checked"],
    });
  });

  $(".yotpo-reviews-list").each((i, list) => {
    function handleChange() {
      $(list)
        .find(".yotpo-thumbnail")
        .removeAttr("aria-selected")
        .attr({
          "aria-label": function () {
            return $(this).attr("alt");
          },
        })
        .removeAttr("alt");
    }

    handleChange();

    const observer = new MutationObserver((mutations) => {
      handleChange();
    });

    observer.observe(list, {
      childList: true,
    });
  });

  $(".yotpo-reviews-main-widget, .yotpo-questions-and-answers").each(
    (i, widget) => {
      const observer = new MutationObserver((mutations) => {
        $(widget)
          .find(".yotpo-new-review-name input")
          .attr("autocomplete", "name");
        $(widget)
          .find(".yotpo-new-review-email input")
          .attr("autocomplete", "email");
      });

      observer.observe(widget, {
        childList: true,
      });
    }
  );

  $("#swym-plugin").each((i, widget) => {
    console.log(widget);
  });

  $(".template-app-home").each((i, page) => {
    $(page)
      .find("h1,h2,h3,h4,h5,h6")
      .each((i, heading) => {
        if (isDOMElementEmpty(heading)) {
          renameElementTag(heading, "div");
        }
      });
  });

  $(".region-select").attr("aria-label", "Select Region");

  $(".collection-products").each((i, widget) => {
    function handlechange() {
      setTimeout(function () {
        $(widget)
          .find(".yotpo-sr-bottom-line-summary > div")
          .removeAttr("aria-label");
        $(widget)
          .find(
            ".yotpo-sr-bottom-line-summary div, .yotpo-sr-bottom-line-summary svg"
          )
          .removeAttr("aria-labelledby");
        $(widget)
          .find(".yotpo-sr-bottom-line-summary svg")
          .attr("aria-hidden", "true");

        $(widget)
          .find("article")
          .each(function () {
            $(this)
              .find(
                ".yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel > div"
              )
              .append('<span class="sr-only">Reviews</span>');
          });
      }, 1000);
    }
    const observer = new MutationObserver((mutations) => {
      handlechange();
    });
    handlechange();

    observer.observe(widget, {
      childList: true,
    });
  });

  $(
    ".yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary > div"
  ).removeAttr("aria-label");
  $(
    ".yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary div, .yotpo-sr-bottom-line-summary svg"
  ).removeAttr("aria-labelledby");
  $(
    ".yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary svg"
  ).attr("aria-hidden", "true");

  $(".swiper-wrapper .swiper-slide.swiper-slide__card").each(function () {
    var link = $(this).find(".productitem--link");
    $(this)
      .find(".a11y_wish_link")
      .click(function () {
        window.open(link.attr("href"), "_self");
      });
  });

  $(".accordion .accordion-title").removeAttr("aria-disabled");
  $(".active button.accordion-title").attr("aria-expanded", "true");

  $("nav.yotpo-reviews-pagination-container").attr("aria-label", "Pagination");
  $(".yotpo-horizontal-pagination").each(function () {
    var parentDiv = $(this);
    var ulElement = $("<ul></ul>");
    // Wrap all the <a> elements inside the <ul>
    parentDiv.find("a").wrapAll(ulElement);
    // Wrap each <a> element inside a <li>
    parentDiv.find("a").wrap("<li></li>");
  });

  $(".yotpo-horizontal-pagination a").each(function () {
    var labelText = $(this).attr("aria-label");
    var modifiedText = labelText.replace(", Current Page", "");
    $(this).attr("aria-label", modifiedText);
  });

  $(".yotpo-sr-bottom-line-summary .star-container").attr(
    "aria-hidden",
    "true"
  );
  $(
    ".yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel .yotpo-sr-bottom-line-text"
  ).append('<span class="sr-only">Reviews</span>');
  $(".icon-list article > span.items-center:first-child").attr(
    "aria-hidden",
    "true"
  );

  setTimeout(function () {
    $(
      ".yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon"
    ).removeAttr("role");
    $(
      ".yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon"
    ).removeAttr("aria-level");
    $(
      ".yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon"
    ).removeAttr("aria-label");
    $(".yotpo-email-container input, .klaviyo-form input").attr(
      "aria-required",
      "true"
    );

    $(".swym-wishlist-context-menu").attr("aria-expanded", "false");
    $(".swym-wishlist-context-menu").click(function () {
      $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
    });
    $(".swym-empty-wishlist-title.swym-heading-1").attr({
      role: "heading",
      "aria-level": "2",
    });
    $(
      ".yotpo-ask-question-btn-wrapper, .yotpo-new-review-btn-wrapper"
    ).removeAttr("tabindex");

    $(".swym-wishlist-grid > div.swym-wishlist-item").each(function () {
      $(this).removeAttr("role");
      $(this).removeAttr("aria-label");
      $(this).removeAttr("tabindex");
      $(this)
        .find(".swym-product-final-price")
        .prepend('<span class="sr-only">Discounted Price</span>');
      $(this)
        .find(".swym-product-original-price")
        .prepend('<span class="sr-only">Regular Price</span>');
      var title = $(this).find(".swym-title-1").text().trim();
      var btn = $(this).find(".swym-add-to-cart-btn").text().trim();
      $(this)
        .find(".swym-add-to-cart-btn")
        .attr("aria-label", btn + " " + title);
    });
    $(".yotpo-main-reviews-widget #yotpo-main-widget-btn").click(function () {
      setTimeout(function () {
        $(".yotpo-review-form-modal .yotpo-modal-header").attr(
          "aria-level",
          "2"
        );
        $(".yotpo-review-form-modal #modalDescription h4").removeAttr("role");
        $(".yotpo-review-form-modal #modalDescription h4").removeAttr(
          "aria-level"
        );
        $(
          ".yotpo-review-form-modal #modalDescription h4, .yotpo-review-form-modal #modalDescription h6"
        ).attr("role", "none");
        var legend = $(
          ".yotpo-review-form-modal .yotpo-new-review-star-rating > legend"
        )
          .text()
          .trim();
        $(
          ".yotpo-review-form-modal .yotpo-new-review-star-rating > legend"
        ).attr("role", "none");
        $(".yotpo-review-form-modal .yotpo-new-review-star-rating").attr({
          role: "group",
          "aria-label": legend,
        });
        $(
          ".yotpo-review-form-modal .yotpo-new-review-email .yotpo-new-input-container"
        ).attr("aria-describedby", "review-email");
        $(
          ".yotpo-review-form-modal .yotpo-new-review-email .yotpo-new-input-container+p"
        ).attr("id", "review-email");

        $(
          ".yotpo-review-form-modal .yotpo-file-upload .yotpo-upload-label"
        ).attr("aria-describedby", "a11y_upload");
        $(
          ".yotpo-review-form-modal .yotpo-file-upload .yotpo-upload-label+p"
        ).attr("id", "a11y_upload");

        // $('.yotpo-review-form-modal .yotpo-new-review-submit').click(function () {
        //   $('.yotpo-single-input-error').attr('role','alert');
        // })
      }, 250);
    });
    $(
      ".yotpo-screen-friends_emails .yotpo-tile-box form .yotpo-button-style"
    ).click(function () {
      setTimeout(function () {
        $(
          ".yotpo-screen-friends_emails .yotpo-tile-box .yotpo-header-text"
        ).removeAttr("tabindex");
      }, 500);
    });
  }, 3000);

  $(".yotpo-background.yotpo-left-align-background img").attr("alt", "");
  $(
    ".standalone-bottomline .yotpo-bottomline.pull-left.star-clickable"
  ).removeAttr("tabindex");

  $(".yotpo-star-ratings-clickable").each(function () {
    $(this).attr({ tabindex: "0", role: "link" });
    $(this).keydown(function (event) {
      if (event.which == "13") {
        $(this).find(".yotpo-sr-bottom-line-summary").click();
        $("#a11y_rating_focus").focus();
      }
    });
  });

  $(".ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs").each(
    function () {
      $(this).attr("role", "tablist");
      $(this)
        .find("div")
        .attr({ role: "tab", "aria-selected": "false", tabindex: "-1" });
      $(this)
        .find("div.selected")
        .attr({ role: "tab", "aria-selected": "true", tabindex: "0" });

      var tabs = $(".ugc-storefront-widgets-tabs-container__tab");
      tabs.on("keydown", function (e) {
        var currentIndex = tabs.index(this);
        switch (e.which) {
          case 39:
            currentIndex = (currentIndex + 1) % tabs.length;
            break;
          case 37:
            currentIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;
          case 13:
            $(this).click();
            tabs
              .attr({ tabindex: "-1", "aria-selected": "false" })
              .removeClass("selected");
            $(this)
              .attr({ tabindex: "0", "aria-selected": "true" })
              .addClass("selected");

            return;
        }
        tabs.attr("tabindex", "-1").removeClass("selected");
        tabs
          .eq(currentIndex)
          .attr("tabindex", "0")
          .addClass("selected")
          .focus();
      });
    }
  );

  $(".yotpo-horizontal-pagination a").each(function () {
    var disable = $(this).hasClass("disabled");
    if (disable == true) {
      $(this).attr("tabindex", "-1");
    }
    $(this).click(function () {
      $(".yotpo-horizontal-pagination a").each(function () {
        var disable = $(this).hasClass("disabled");
        if (disable == true) {
          $(this).attr("tabindex", "-1");
        } else $(this).attr("tabindex", "0");
      });
    });
  });

  $(".yotpo-widget-products-redemption-container").each(function () {
    var title = $(this).find(".yotpo-headline").text().trim();
    $(this)
      .find(".yotpo-carousel-button-next")
      .attr({
        tabindex: "0",
        role: "button",
        "aria-label": "Next Slide of" + " " + title,
      });
    $(this)
      .find(".yotpo-carousel-button-prev")
      .attr({
        tabindex: "0",
        role: "button",
        "aria-label": "Previous Slide of" + " " + title,
      });
    $(this)
      .find(".yotpo-carousel-button-next, .yotpo-carousel-button-prev")
      .keydown(function (event) {
        if (event.which === 13) {
          $(this).click();
        }
      });
  });

  A11YFix.FixSliders();

  console.log("Load");
});

function renameElementTag(oldElementSelector, newTag) {
  var oldElement = $(oldElementSelector);

  if (oldElement.length > 0) {
    var newElement = $("<" + newTag + "></" + newTag + ">");

    newElement.html(oldElement.html());

    $.each(oldElement[0].attributes, function () {
      newElement.attr(this.name, this.value);
    });

    oldElement.replaceWith(newElement);
  }
}

function isDOMElementEmpty(element) {
  if (element === null || element === undefined) {
    return true;
  }

  var $element = $(element);

  if ($element.length === 0 || !$element.text().trim()) {
    return true;
  }

  return $element.is(":empty");
}
